import axios from "axios"
import { useState } from "react"
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { API_URL } from "../../../../config";


export default function Contact() {
  const [form, setForm] = useState({ name: '', email: '', phone: '', message: '' })
  const [errors, setErrors] = useState({});
  const handleClick = (e) => {

    e.preventDefault()
    axios.post(`${API_URL}/api/contact/newcontact`, form)
      .then((response) => {
        setForm(response.data)
        setForm({ name: '', email: '', phone: '', message: '' });
        console.log("data submitted successfully", form)
      })


      .catch((error) => console.log("error in the api", error))

  }
  return (
    <>
      <div className="col-lg-6 mx-auto d-flex justify-content-center align-items-center">
        <form onSubmit={handleClick}
          action=""
          className=" border border-2 rounded-4 p-4 w-100 h-100 row"
        >
          <h2 className="h2-heading fw-semibold fs-4 mb-2">
            Connect with us
          </h2>
          <div className="mb-3">
            <input
              type="text"
              placeholder="Name"
              className="px-2 py-1 rounded-2"
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
              style={{
                width: "100%",
                border: "1px solid black",
                height: "45px",
                outline: "none",
                fontSize: "14px"
              }}
            />
          </div>
          <div className="mb-3">
            <input
              type="email"
              placeholder="Email"
              className="px-2 py-1 rounded-2"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              style={{
                width: "100%",
                border: "1px solid black",
                height: "45px",
                outline: "none",
                fontSize: "14px"
              }}
            />
          </div>
          <div className="mb-3">
            <PhoneInput
              country={"in"}
              value={form.phone}
              placeholder="Enter your phone number"
              onChange={(value) =>
                setForm((prev) => ({
                  ...prev,
                  phone: value,
                }))
              }
              inputStyle={{
                width: "100%",
                height: "45px",
                fontSize: "14px",
                border: "1px solid black",
                borderRadius: "4px",
                outline: "none"
              }}
              buttonStyle={{
                border: "1px solid black",
                borderRadius: "4px 0 0 4px",
                backgroundColor: "#fff"
              }}
              containerStyle={{
                width: "100%"
              }}
            />
            {errors.phone && (
              <div className="error-message">{errors.phone}</div>
            )}
          </div>
          <div className="mb-3">
            <textarea
              placeholder="Message"
              className="px-2 py-1 rounded-2"
              value={form.message}
              onChange={(e) => setForm({ ...form, message: e.target.value })}
              style={{
                width: "100%",
                border: "1px solid black",
                minHeight: "100px",
                outline: "none",
                fontSize: "14px"
              }}
            ></textarea>
          </div>
          <div className="col-12">
            <button className="bg-warning h1-para  text-center  btn-gradient rounded-3 text-white px-4 py-2">
              Submit
            </button>
          </div>
        </form>
      </div>
    </>
  )
}